<template lang='pug'>
  .left-nav.component
    slot
</template>

<script>
  export default {
    name: 'left-nav.component',
  }
</script>

<style scoped lang='stylus'>
  .left-nav
    position absolute
    border 1px solid gray
    top 41px
    right 4px
    width 250px
    flex-direction column
    z-index 3
    overflow-y auto
    // padding 12px 0 0 0 
    padding 8px 0
    box-shadow var(--shadow-panel)
    background white
    display none
    &.open
      display flex
</style>
